import React, { useState, useEffect,useRef} from 'react';
import Row from '../components/QuotSubDetail.js'
import DatePicker from 'react-datepicker'; 
import Layout from './Layout';
import Box from '@mui/material/Box';
import { DataGrid, GridToolbar  } from '@mui/x-data-grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import Helper from './Helper';
import VirtualizedSelect from 'react-virtualized-select';
import axios, { AxiosError } from 'axios';
import { apiUrl } from './UrlParam';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useParams , useNavigate} from 'react-router-dom';
import ConfirmationButton from '../components/ConfirmationButton'  ;
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import AxiosFetchData from './AxiosFetchData';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Typography, Modal
} from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
 
import Paper from '@mui/material/Paper';
import {useAddPOHook} from '../hook/AddPOHook.js'
import DynamicSelect from '../components/DynamicSelect.js'


const AddPO = () => {
  const { id } = useParams();
  const { id2 } = useParams();
  const { id4 } = useParams();

  const {message,setmessage,tipe,settipe,handleSave,poCode,value,handleChangeTab,type,open,handleClick,anchorEl,menuOpen,handleMenuClose,handleRev,revTemp,rev,handleDefault,handleDelete,poType,setSelectedOptionPoType,selectedOptionPoType,poDate,setPoDate,setValidUntil,validUntil,customer,setCustomer,contactPerson,setContactPerson,customerPhone,setCustomerPhone,customerEmail,setCustomerEmail,paymentOption,setSelectedOptionPayment,selectedOptionPayment,subject,role,setSubject,notes,setNotes,roleAccess,handleClickOpen,productRows,handleEdit,disc,handleDisc,discValue,setDiscValue
    ,totalHpp2,comm,setComm,commValue,setCommValue,ppn,setPpn,pph,setPph,total,setTotal,totalDisc,setTotalDisc,totalPpn,setTotalPpn,totalPph,setTotalPph,grandTotal,setGrandTotal,revRows,revColumns,handleClose,handleSubmit,rows,columns,handleRowClick,product,setProduct,unitList,setSelectedOptionUnit,selectedOptionUnit,price,setPrice,totalPrice,setTotalPrice,qty,handleQty,hpp,setHpp,totalHpp,setTotalHpp,typeServiceList,setselectedTypeService,descriptions,setDescription,confirmDelegasiOpen,setConfirmDelegasiOpen,columnsDelegasi,rowsDelegasi,filterModel2,setFilterModel2,columnVisibilityModel,setColumnVisibilityModel
    ,poList,handleDelegation,setTotalHpp2,selectedTypeService} = useAddPOHook(id,id2,id4)
     
    return (
        <>
        <Layout message={message} setmessage={setmessage} tipe={tipe} settipe={settipe}>
        <form onSubmit={handleSave} id="myform">
            <div className='pd' style={{backgroundColor:'white' ,position:'relative',height:70,paddingTop:10 }}>
            
                <div style={{position:'absolute', left:12}} >
                    {/* <h4><b>{id2 == 0 ? "NEW PO" :  "#" + poCode} [Rev.{rev}]</b></h4> */}
                    {/* {(role !== "PM") && (
                     <h4><b>{id2 == 0 ? "NEW ADDITIONAL WORK" :  "#" + poCode} </b></h4> 
                    )} */}

                  {(id4 !== "DetailAll" && id4 !== "Detail") && (
                     <h4><b>{id4 == "ADD" ? "NEW ADDITIONAL WORK" :  "#" + poCode} </b></h4> 
                  )}

                  {(id4 === "Detail") && (
                     <h4><b>{"#" + poCode} </b></h4> 
                  )}
  
                  {id4=="DetailAll" && (
                    <Tabs
                      value={value}
                      onChange={handleChangeTab}
                     // textColor="secondary"
                     // indicatorColor="secondary"
                      //aria-label="secondary tabs example"
                      sx={{fontSize:15}}
                    >
                      {poList.map((product2, index2) => (
                            <Tab value={product2.id} label={<span style={{fontSize:14}}>{product2.quotation_id}</span>} />
                      ))}
                      {/* <Tab value="one" label={id2 == 0 ? "NEW ADDITIONAL WORK" :  "#" + poCode} />
                      <Tab value="two" label="Item Two" />
                      <Tab value="three" label="Item Three" /> */}
                    </Tabs>
                  )}
                </div>
                
                <div  style={{position:'absolute', right:12}}>
                <div className='text-right' style={{display:'flex'}} >
                    {(id4 == "ADD" || id4 == "Edit") && (
                      <div className='mr-2'>
                        <ConfirmationButton classname='btn btn-success' text="Do you want save this data?" type="submit" title="save" disabled={!roleAccess.UPDATE}  formid="myform" id="btnSubmit" >
                          SAVE
                        </ConfirmationButton>
                      </div>
                    )}

                    {(id4 == "DetailAll") && (
                    <div>
                      <ConfirmationButton classname='btn btn-success' text="Do you want set delegation?" type="button" title="delegation" disabled={!roleAccess.UPDATE}  onClick={() => handleDelegation()} >
                        DELEGATION
                      </ConfirmationButton>
                    </div> 
                    )}
                      
                    {/* {(type == 0 || (role.toUpperCase() == "SUPERADMIN" && id4=="ADD") || (role.toUpperCase() == "SUPERADMIN" && id4=="Edit")) && (
                      <ConfirmationButton classname='btn btn-success' text="Do you want save this data?" type="submit" title="save" disabled={!roleAccess.UPDATE}  formid="myform" id="btnSubmit" >
                        SAVE
                      </ConfirmationButton>
                    )}     

                    {(role == "PM" || (role.toUpperCase() == "SUPERADMIN" && id4 == "DetailAll"))  && (
                      <ConfirmationButton classname='btn btn-success' text="Do you want set delegation?" type="button" title="delegation" disabled={!roleAccess.UPDATE}  onClick={() => handleDelegation()} >
                        DELEGATION
                      </ConfirmationButton>
                    )}      */}

                    </div>
                    <div className='text-right' style={{display:'none'}}>
                    {type == 0 && (
                    <>
                     <Button
                        id="basic-button"
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={(evt) => handleClick(evt)}
                      >
                      <MoreVertIcon sx={{ fontSize: 30 }}/>
                      </Button>
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={menuOpen}
                        onClose={handleMenuClose}
                        MenuListProps={{
                          'aria-labelledby': 'basic-button',
                        }}
                      >
                        <MenuItem   disabled={id2==0 ? true : false} onClick={() => handleRev('add')} ><AddIcon sx={{ fontSize: 15 }}/>&nbsp;&nbsp;NEW REVISION</MenuItem>
                        <MenuItem   disabled={id2==0 ? true : (revTemp == rev ? true : false)} onClick={() => handleRev('remove')} ><RemoveIcon sx={{ fontSize: 15 }}/>&nbsp;&nbsp;CANCEL REVISION</MenuItem>
                        <MenuItem  disabled={id2==0 ? true : false}  onClick={() => handleDefault()} ><CheckCircleIcon sx={{ fontSize: 15 }}/>&nbsp;&nbsp;SET DEFAULT PO</MenuItem>
                        <MenuItem   disabled={id2==0 ? true : false} onClick={() => handleDelete()} ><LocalPrintshopIcon sx={{ fontSize: 15 }}/>&nbsp;&nbsp;PRINT PO</MenuItem>
                      </Menu>
                       </> 
                    )} 
                    
                        
                     
                  </div>
                </div>
              
                {/* <div className='col-md-1  text-right' style={{borderStyle:'solid'}}>
               
                </div> */}
             
            
        </div>
         <div>
       
           
             <div className='container-fluid' style={{backgroundColor:"white"}} >
             <Box sx={{ p: 2,m:0, border: '1px solid grey',backgroundColor :"#f6f6f6", marginBottom:3}}>
                
                    
                  <div className='row'>
                       <div className='col-lg-6'>
                            <div className='row mb-3'>
                                <div className='col-lg-4 p-3'>
                                    <span>PO Type</span>
                                     
                                    <VirtualizedSelect 
                                       options={poType}
                                       //onChange={(option) => setSelectedOptionPayment(option)}
                                       onChange={(option) => setSelectedOptionPoType(option.value)}
                                       value={selectedOptionPoType}
                                       //disabled={isSubmitDisabled}
                                       required
                                      // disabled={type == 0 ? false : true }
                                        disabled={true}
                                    />
                                </div>
                                <div className='col-lg-4 p-3'>
                                <span>PO Date</span>
                                <div>

                                <DatePicker 
                                  showIcon
                                   selected={poDate}
                                   onChange={(date) => {
                                    setPoDate(date); 
                                    var chooseDate=new Date(date);
                                    chooseDate.setDate(chooseDate.getDate()+6);
                                    setValidUntil(chooseDate);
                                }}
                                //disabled={type == 0 ? false : true }
                                disabled={true}
                                  placeholder="PO Date"
                                  fontSize={8}
                                  dateFormat="dd-MM-yyyy"
                                  className="form-control"/>
                                </div>
                                
                                </div>
                                <div className='col-lg-4 p-3'>
                                <span>Valid Until</span>
                                <div>
                                <DatePicker 
                                  showIcon
                                   selected={validUntil}
                                  onChange={(date) => setValidUntil(date)}
                                //  disabled={type == 0 ? false : true }
                                  disabled={true}
                                  fontSize={8}
                                  dateFormat="dd-MM-yyyy"
                                  className="form-control"/>
                                   </div>
                                </div>
                            </div>

                            <div className='row mb-3'>
                                <div className='col-lg-12 p-3'>
                                    <span>Customer</span>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Customer"
                                       value={customer}
                                      required
                                       onChange={(e) => setCustomer(e.target.value)}
                                       disabled={true}
                                    />
                                </div>
                                 
                            </div>
                            <div className='row mb-3'>
                                
                                <div className='col-lg-6 p-3'>
                                <span>Contact Person</span>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Contact Person"
                                      value={contactPerson}
                                      required
                                       onChange={(e) => setContactPerson(e.target.value)}
                                       disabled={true}
                                    />
                                </div>
                                <div  className='col-lg-6 p-3'>
                                    <span>Contact Phone</span>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Contact Person"
                                      value={customerPhone}
                                      required
                                       onChange={(e) => setCustomerPhone(e.target.value)}
                                       disabled={true}
                                    />
                                </div>
                            </div>
                            <div className='row mb-3'>
                                
                                <div className='col-lg-6 p-3'>
                                <span>Contact Email</span>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Contact Person"
                                      value={customerEmail}
                                      required
                                       onChange={(e) => setCustomerEmail(e.target.value)}
                                       disabled={true}
                                    />
                                </div>
                                <div  className='col-lg-6 p-3'>
                                    <span>Payment Term</span>
                                    <DynamicSelect url={"GetPaymentTerm"} onChange={(option) => setSelectedOptionPayment(option)} id="optPayment" disabled={true} selectedvalue={selectedOptionPayment} label="{id} - {name}" value="id"></DynamicSelect>
                                    {/* <VirtualizedSelect 
                                       options={paymentOption}
                                       //onChange={(option) => setSelectedOptionPayment(option)}
                                       onChange={(option) => setSelectedOptionPayment(option)}
                                       value={selectedOptionPayment}
                                       //disabled={isSubmitDisabled}
                                       required
                                        disabled={ true }
                                       //disabled={type == 0 ? false : true }
                                    /> */}
                                </div>
                            </div>
                       </div>
                       <div className='col-lg-6'>
                          <div className='row mb-3'>
                                <div  className='col-lg-12 p-3'>
                                    <span>Subject / Title</span>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Subject / Title"
                                      value={subject}
                                      required
                                      // disabled={type == 0 ? false : true}
                                      disabled={type == 0 ? false : role.toUpperCase() == "SUPERADMIN" ? false : true}
                                      onChange={(e) => setSubject(e.target.value)}
                                    />
                                </div>
                                 
                            </div>
                            <div className='row'>
                                <div  className='col-lg-12 p-3'>
                                    <span>Notes</span>
                                    <textarea  rows="5" cols="50"  className="form-control"  value={notes} onChange={(e) => setNotes(e.target.value)} disabled={type == 0 ? false : role.toUpperCase() == "SUPERADMIN" ? false : true}/>
                                </div>
                            </div>
                       </div>
                  </div>
                  <div className='row'>
                        <div className='col-lg-12 mb-3 text-right'>
                            <button type='button' disabled={!roleAccess.UPDATE} className='btn btn-info' onClick={handleClickOpen} >+ ADD ITEM</button>
                        </div>
                
                  </div>
                  <div className='row mb-6'>
                    <div className='col-lg-12'>
                  
                        <TableContainer component={Paper}>
                          <Table aria-label="collapsible table">
                            <TableHead>
                              <TableRow>
         
                              <TableCell></TableCell>
            <TableCell sx={{fontSize:12}} >No</TableCell>
            <TableCell ></TableCell>
            <TableCell align="right"  sx={{fontSize:12}}>Part No</TableCell>
            <TableCell align="right"  sx={{fontSize:12}}>Descriptions</TableCell>
            <TableCell align="right"  sx={{fontSize:12}}>Qty</TableCell>
            <TableCell align="right"  sx={{fontSize:12}}>Unit</TableCell>
            <TableCell align="right"  sx={{fontSize:12}}>Price</TableCell>
            <TableCell align="right"  sx={{fontSize:12}}>Total</TableCell>
            <TableCell align="right"  sx={{fontSize:12}}>HPP</TableCell>
            <TableCell align="right"  sx={{fontSize:12}}>HPP TOTAL</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {productRows.filter((item) => item.parent_id == null).map((row,index) => (
            <Row index={index} key={row.descriptions} row={productRows.filter((item2) => item2.parent_id == row.id)} parentrow={row} handleDelete={handleDelete} handleEdit={handleEdit} params={id4} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
                    </div>
                 </div>
                 <div className='row'>
                      <div className='col-lg-8'>
                      <div class="form-group row">
                         <span for="staticEmail" class="col-sm-2">Disc %</span>
                         <div class="col-sm-2">
                           <input type="number" min={0} step=".01" readonly class="form-control"  value={disc} onChange={(e) => handleDisc(e.target.value)} disabled={type == 0 ? false : true } />
                        </div>
                        <span for="staticEmail" class="col-sm-1" style={{textAlign:"right"}}>Rp</span>
                        <div class="col-sm-3">
                           <input type="text"  disabled={true} class="form-control" value={Helper.formatAsCurrency(discValue)} onChange={(e) => setDiscValue(e.target.value)}   />
                        </div>
                        <span for="staticEmail" class="col-sm-1" style={{textAlign:"right"}}>Hpp Total</span>
                        <div class="col-sm-3">
                           <input type="text" disabled={true} class="form-control"    value={Helper.formatAsCurrency(totalHpp2)} onChange={(e) => setTotalHpp2(e.target.value)} />
                        </div>
                      </div>

                      <div class="form-group row">
                         <span for="staticEmail" class="col-sm-2">Comm %</span>
                         <div class="col-sm-2">
                           <input type="number" min={0} step=".01"  disabled={true}  value={comm} onChange={(e) => setComm(e.target.value)} class="form-control"   />
                        </div>
                        <span for="staticEmail" class="col-sm-1" style={{textAlign:"right"}}>Rp</span>
                        <div class="col-sm-3">
                           <input type="text" disabled={true} class="form-control"  value={Helper.formatAsCurrency(commValue)} onChange={(e) => setCommValue(e.target.value)}/>
                        </div>
                         
                      </div>
                      <div class="form-group row">
                         <span for="staticEmail" class="col-sm-2">PPN %</span>
                         <div class="col-sm-2">
                           <input type="number" min={0} disabled={true} value={ppn} onChange={(e) => setPpn(e.event.target)}  class="form-control"  />
                        </div>
                        
                         
                      </div>
                      <div class="form-group row">
                         <span for="staticEmail" class="col-sm-2">PPH %</span>
                         <div class="col-sm-2">
                           <input type="number" min={0}   disabled={true} value={pph} onChange={(e) => setPph(e.event.target)} readonly class="form-control"  />
                        </div>
                      </div>
                       
                       </div>
                       <div className='col-lg-4'>
                         <div class="form-group row">
                            <span for="staticEmail" class="col-sm-4">TOTAL</span>
                            <div class="col-sm-8">
                              <input type="text"   class="form-control" disabled={true} value={Helper.formatAsCurrency(total)} onChange={(e) => setTotal(e.event.target)}   />
                           </div>
                         </div>
                         <div class="form-group row">
                            <span for="staticEmail" class="col-sm-4">DISC</span>
                            <div class="col-sm-8">
                              <input type="text"   class="form-control"  disabled={true} value={Helper.formatAsCurrency(totalDisc)} onChange={(e) => setTotalDisc(e.event.target)}/>
                           </div>
                         </div>
                         <div class="form-group row">
                            <span for="staticEmail" class="col-sm-4">PPN</span>
                            <div class="col-sm-8">
                              <input type="text"   class="form-control" disabled={true} value={Helper.formatAsCurrency(totalPpn)} onChange={(e) => setTotalPpn(e.event.target)}/>
                           </div>
                         </div>
                         <div class="form-group row">
                            <span for="staticEmail" class="col-sm-4">PPH</span>
                            <div class="col-sm-8">
                              <input type="text"   class="form-control" disabled={true} value={Helper.formatAsCurrency(totalPph)} onChange={(e) => setTotalPph(e.event.target)}/>
                           </div>
                         </div>
                         <div class="form-group row">
                            <span for="staticEmail" class="col-sm-4">Grand Total</span>
                            <div class="col-sm-8">
                              <input type="text"   class="form-control" disabled={true} value={Helper.formatAsCurrency(grandTotal)} onChange={(e) => setGrandTotal(e.event.target)}/>
                           </div>
                         </div>
                       </div>
                 </div>
               
                  </Box>
             </div>
          </div>
        {id2!=0 && (id2 != id) && (
          <div>
                <div className='container-fluid' style={{backgroundColor:"white",display:'none'}} >
                <h3>Revision History    </h3>
                  <Box sx={{ p: 2,m:0, border: '1px solid grey',backgroundColor :"#f6f6f6", marginBottom:3}}>
                    <DataGrid rows={revRows}  columns={revColumns}  className='fonty' getRowId={(row) => row.po_id} />  
                  </Box>
                </div>
          </div>
          )}
          </form>
       
      
          <Dialog
             open={open}
             onClose={handleClose}
             maxWidth="md"
             
          >
            <form onSubmit={handleSubmit} role="form"> 
          <DialogTitle>NEW PO ITEM</DialogTitle>
          
        <DialogContent>
          <DialogContentText>
          please select an item from the list below.
          </DialogContentText>
          <div className='row mb-6'>
             <div className='col-lg-12'>
             <DataGrid rows={rows} keepNonExistentRowsSelected  columns={columns} onRowClick={handleRowClick} className='fonty'  rowSelectionModel={product} 
                onRowSelectionModelChange={(newRowSelectionModel) => {
                 
                setProduct(newRowSelectionModel);
                
                }}
                getRowId={(row) => row.id} />
             </div>
           
          </div>
        
          <div className='row mb-6'>
            
             <div className='col-lg-4'>
                <span>Unit :</span>
                <DynamicSelect url={"GetUnits"} onChange={(option) => setSelectedOptionUnit(option)} id="optUnit" disabled={true} selectedvalue={selectedOptionUnit} label="{id} - {name}" value="id"></DynamicSelect>
                {/* <VirtualizedSelect 
                        options={unitList}
                        onChange={(option) => setSelectedOptionUnit(option)}
                        value={selectedOptionUnit}
                        disabled={true}/> */}
                
             </div>
             <div className='col-lg-4'>
             <span>Selling Price :</span>
                <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Customer"
                                       value={Helper.formatAsCurrency(price)}
                                      required
                                     onChange={(e) => setPrice(e.target.value)}
                                     readOnly={true}
                                    />
             </div>
             <div className='col-lg-4'>
             <span>Total :</span>
                <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Customer"
                                      value={Helper.formatAsCurrency(totalPrice)}
                                      required
                                       onChange={(e) => setTotalPrice(e.target.value)}
                                       disabled={true}
                                    />
             </div>
          </div>
          <div className='row mb-6'>
             <div className='col-lg-4'>
                <span>Qty :</span>
                <input
                                      type="number"
                                      className="form-control"
                                      placeholder="Customer"
                                      value={qty}
                                      min={0}
                                      required
                                      onChange={(e) => handleQty(e.target.value)}
                                    />
             </div>
             <div className='col-lg-4'>
             <span>Cost Price :</span>
                <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Customer"
                                       value={Helper.formatAsCurrency(hpp)}
                                      required
                                      onChange={(e) => setHpp(e.target.value)}
                                      readOnly={true}
                                    />
             </div>
             <div className='col-lg-4'>
             <span>Cost Total :</span>
                <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Customer"
                                      value={Helper.formatAsCurrency(totalHpp)}
                                      required
                                      onChange={(e) => setTotalHpp(e.target.value)}
                                      disabled={true}
                                    />
             </div>
          </div>
          <div className='row'>
              <div className='col-lg-4'>
                    <span>Type Service :</span>
                    
                    <VirtualizedSelect 
                                       options={typeServiceList}
                                       //onChange={(option) => setSelectedOptionPayment(option)}
                                       onChange={(option) => setselectedTypeService(option)}
                                       value={selectedTypeService}
                                        disabled={true}
                                       required
                                    />
              </div>
              <div className='col-lg-8'>
                    <span>Descriptions :</span>
                    <textarea id="txtDesc" name="txtDesc" rows="5" cols="50"  className="form-control" value={descriptions} onChange={(option) => setDescription(option)} disabled={true}/>
              </div>
         </div>
        </DialogContent>
        <DialogActions>
          <button className='btn' onClick={handleClose} type='button'>CANCEL</button>
          <button className='btn'>ADD</button>
        </DialogActions>
        </form>
      </Dialog>


      <Modal
        open={confirmDelegasiOpen}
        onClose={() => setConfirmDelegasiOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className='modals-delegasi' >
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <h3>Delegation</h3>
          </Typography>
          <Typography id="modal-modal-description">
          <Box sx={{ width: 1 }} >
     
      <Box sx={{ height: 550 }} >
        <DataGrid className='fonty'
          columns={columnsDelegasi}
          rows={rowsDelegasi.map((row) => ({
            ...row,
            id: row.id, // Set 'acid' as the unique key for each row
          }))}
          disableColumnFilter
          disableDensitySelector
          disableColumnSelector
        //  EnableColumnFilter
       //   EnableDensitySelector
          slots={{ toolbar: GridToolbar }}
          filterModel={filterModel2}
          onFilterModelChange={(newModel) => setFilterModel2(newModel)}
          slotProps={{ toolbar: { showQuickFilter: true } }}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={(newModel) =>
            setColumnVisibilityModel(newModel)
          }
          getRowId={(row) => row.id}
        />
      </Box>
    </Box>
           
          </Typography>
        </Box>
      </Modal>
          </Layout>
          </>
    )
}

export default AddPO;